var link_viewer_default = {
  "fontElementMap": "GERUY",
  "link": "XXkyJ",
  "linkInEditor": "-GGGv",
  "linkInViewer": "Z9L1b",
  "toolbarUrlContainer": "GEYVh",
  "toolbarUrl": "yaUMA",
  "toolbarUrlAnchor": "iTjlD"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
